import {Component} from "react";
import ns from "../../media/nuestros_servicios.jpg";
import "./Servicios.css";
import tyc from "../../media/Servicios/TapasyTacones.png";
import suelas from "../../media/Servicios/Suelas.png"
import costuras from "../../media/Servicios/Costuras.png";
import boleado from "../../media/Servicios/Boleado.png";
import hormado from "../../media/Servicios/Hormado.png";
import plantillas from "../../media/Servicios/plantillas.jpg";
import aumentos from "../../media/Servicios/aumentos.jpg";
import taloneras from "../../media/Servicios/taloneras.jpg";
import ContactForm from "../ContactForm/ContactForm";
import {fillButtons} from "../../Helpers/Actions";

export default class Servicios extends Component {
    render() {
        return (
            <div className="servicios-container">
                <div className="banner">
                    <img src={ns} alt=""/>
                    <button className="selected" onClick={fillButtons} value={"reparacion"}>Reparación</button>
                    <button onClick={fillButtons} value={"ortopedia"}>Ortopédia</button>
                </div>
                <div className="container servicios reparacion">
                    <div className="servicio-container" id={"tapas"}>
                        <img src={tyc} alt="tapas_y_tacones"/>
                        <div className="servicio-text">
                            <div className="servicio-title">
                                Tapas y tacones
                            </div>
                            <div className="servicio-content">
                                Si tus zapatos tienen las tapas desgastadas o se resbalan mucho, ofrecemos el servicio de cambio de tapas con materiales duraderos y antiderrapantes.
                                <br/>Si tus tacones vienen dañados, también ofrecemos el servicio de cambio, forrado y pintado.
                            </div>
                        </div>
                    </div>
                    <div className="servicio-container" id={"suelas"}>
                        <img src={suelas} alt="tapas_y_tacones"/>
                        <div className="servicio-text">
                            <div className="servicio-title">
                                Suelas
                            </div>
                            <div className="servicio-content">
                                Tenemos el servicio de cambio de suelas, si las suelas de tus zapatos se partieron,agrietaron o alisaron. Poseemos una amplia variedad de modelos y materiales para tu calzado.
                            </div>
                        </div>
                    </div>
                    <div className="servicio-container" id="costuras">
                        <img src={costuras} alt="tapas_y_tacones"/>
                        <div className="servicio-text">
                            <div className="servicio-title">
                                Costuras y detalles
                            </div>
                            <div className="servicio-content">
                                Reparación de bolsas, mochilas, parches, adornos, asas, etc. Trabajamos con piel para que la reparación de tu calzado y accesorios sea de alta calidad.
                            </div>
                        </div>
                    </div>
                    <div className="servicio-container" id={"boleado"}>
                        <img src={boleado} alt="tapas_y_tacones"/>
                        <div className="servicio-text">
                            <div className="servicio-title">
                                Pintura, lavado y boleado
                            </div>
                            <div className="servicio-content">
                                Si tus zapatos y accesorios están decolorados, raspados, sucios o los quieres cambiar de color. <br/>
                                Trabajamos con zapatos de piel, ante, gamuza, nobuck, etc. Así como chamarras, bolsas y otros artículos de piel.
                            </div>
                        </div>
                    </div>
                    <div className="servicio-container" id={"hormado"}>
                        <img src={hormado} alt="tapas_y_tacones"/>
                        <div className="servicio-text">
                            <div className="servicio-title">
                                Hormado
                            </div>
                            <div className="servicio-content">
                                En caso que tu calzado te apriete y/o lastime de alguna parte, contamos con herramientas especiales para estirar y hacer que tus zapatos te queden mejor.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container servicios ortopedia d-none">
                    <div className="servicio-container" id="plantillas">
                        <img src={plantillas} alt="tapas_y_tacones"/>
                        <div className="servicio-text">
                            <div className="servicio-title">
                                Elaboración de plantillas ortopédicas
                            </div>
                            <div className="servicio-content">
                                Elaboración de plantillas ortopédicas hechas con materiales destinados a la comodidad de sus pies.
                            </div>
                        </div>
                    </div>
                    <div className="servicio-container" id={"aumentos"}>
                        <img src={aumentos} alt="tapas_y_tacones"/>
                        <div className="servicio-text">
                            <div className="servicio-title">
                                Aumentos a la medida
                            </div>
                            <div className="servicio-content">
                                Aumentos para incrementar la altura de uno de sus zapatos en caso que haya un acortamiento o condición médica que lo amerite.                            </div>
                        </div>
                    </div>
                    <div className="servicio-container" id={"taloneras"}>
                        <img src={taloneras} alt="tapas_y_tacones"/>
                        <div className="servicio-text">
                            <div className="servicio-title">
                                Taloneras niveladoras a la medida
                            </div>
                            <div className="servicio-content">
                                Venta de rodilleras, coderas, cómodos, muñequeras, bastones, andaderas, sillas de ruedas, etc.
                            </div>
                        </div>
                    </div>

                </div>
                {<ContactForm/>}

            </div>
        )
    }
}